<template>
    <div>
        <form-label v-if="label" :name="name" :has-error="form && form.errors.hasOwnProperty(name)" has-margin>
            {{ label }}
        </form-label>
        <div class="relative rounded-md shadow-sm">
            <div v-if="icon" class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <icon
                    :name="icon"
                    :class="{ 'text-red-500 dark:text-red-400': form && form.errors.hasOwnProperty(name) }"
                    class="w-4 text-gray-500 dark:text-gray-300"
                />
            </div>
            <slot>
                <input
                    :id="name"
                    :name="name"
                    :autocomplete="autocomplete"
                    :class="[{ 'border-red-500 dark:border-red-500': form && form.errors.hasOwnProperty(name), 'pl-10': icon }, formResetClass]"
                    :type="type"
                    :step="step"
                    class="form-input default-input"
                    :placeholder="placeholder"
                    :value="value"
                    :required="required"
                    v-bind="inputAttributes"
                    @input="$emit('input', $event.target.value)"
                />
            </slot>
        </div>
        <template v-if="help && !(form && form.errors.hasOwnProperty(name))">
            <form-help>{{ help }}</form-help>
        </template>
        <has-error v-if="form" :form="form" :field="name"/>
    </div>
</template>

<script>
import HasError from '../../HasError';
import FormLabel from '../Label';
import FormHelp from '../Help';

export default {
    name: 'InputGroup',
    components: {FormHelp, FormLabel, HasError},

    props: {
        value: {
            type: [Number, String, Array],
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'text',
        },
        form: {
            type: Object,
            default: () => {},
        },
        label: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        icon: {
            type: String,
        },
        autocomplete: {
            type: String,
        },
        help: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        step: {
            default: 1,
        },
        inputAttributes: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        formResetClass() {
            if (this.type === 'textarea') {
                return 'form-textarea';
            }

            if (this.type === 'checkbox') {
                return 'form-checkbox';
            }

            if (this.type === 'radio') {
                return 'form-radio';
            }

            return 'form-input';
        }
    },
};
</script>
